// app/javascript/application.js
//
// ARCHITETTURA CORRETTA (Rails 7/8 + Stimulus + Turbo)
// application.js        → entrypoint JS
// controllers/
//   application.js      → UNICA istanza Stimulus
//   index.js            → carica i controller
//   *_controller.js     → controller

// -------------------------
// Rails e Turbo
// -------------------------
import Rails from "@rails/ujs"       // ✅ Rails UJS per data-method, data-confirm
Rails.start()

import "@hotwired/turbo-rails"      // ✅ Turbo (opzionale se vuoi mantenere Turbo)

import { application } from "./controllers/application"
import "./controllers" 

// -------------------------
// Bootstrap + jQuery
// -------------------------
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap
import $ from "jquery"

window.$ = $
window.jQuery = $

// FontAwesome
import "@fortawesome/fontawesome-free/css/all.min.css"
import "@fortawesome/fontawesome-free/js/all.min.js"

// -------------------------
// Cocoon (nested forms)
// -------------------------
import "cocoon-js"

// -------------------------
// Funzioni utility
// -------------------------
const initPopovers = () => {
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach(el => {
    if (!el._popover) {
      el._popover = new bootstrap.Popover(el)
    }
  })
}

// -------------------------
// Eventi Turbo
// -------------------------
document.addEventListener("turbo:load", initPopovers)
document.addEventListener("turbo:render", initPopovers)

document.addEventListener("turbo:load", () => {
  document
    .querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach(el => new bootstrap.Tooltip(el))
})

// -------------------------
// Pulizia modali Bootstrap dopo submit
// -------------------------
document.addEventListener("turbo:submit-end", () => {
  document.body.classList.remove("modal-open")
  document.querySelectorAll(".modal-backdrop").forEach(el => el.remove())
})

document.addEventListener("show.bs.modal", event => {
  const button = event.relatedTarget
  if (!button) return

  const imageUrl = button.dataset.imageUrl
  const modal = event.target
  const img = modal.querySelector("#modalFoto")

  if (img && imageUrl) {
    img.src = imageUrl
  }
})

// -------------------------
// Ripristino del focus alla pagina sottostante dopo 
// chiusura di un popup modale a seguito di errore di validazione
// -------------------------
document.addEventListener("hidden.bs.modal", function () {
  document.body.classList.remove("modal-open");
  document.body.style.removeProperty("overflow");

  document.querySelectorAll(".modal-backdrop").forEach(el => el.remove());
});

// PRIMA di importare trix
// NON usare turbo:load per le traduzioni
// Questo evento è l’unico momento valido
document.addEventListener("trix-before-initialize", () => {
  if (window.TRIX_I18N) {
    Object.assign(Trix.config.lang, window.TRIX_I18N)
  }
})

import "trix"
import "trix/dist/trix.css"  // necessario se vuoi stile predefinito

// Quando Trix crea un editor
document.addEventListener("trix-initialize", function(event) {
  // console.log("Trix inizializzato:", event.target)
})
